module.exports = __webpack_public_path__ + "assets/img/dafb-st.svg";